<template>
  <v-multiselect
    v-model="fieldModelValue"
    label="text"
    track-by="value"
    :options="options"
    :searchable="false"
    :disabled="!editable"
    :allow-empty="false">
    <template #placeholder>
      {{ $t('common.SelectOne') }}
    </template>
  </v-multiselect>
</template>
<script>
export default {
  name: 'BoolInput',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      options: [
        { value: false, text: this.$t('common.Paper') },
        { value: true, text: this.$t('common.Digital') }
      ]
    };
  },
  computed: {
    fieldModelValue: {
      get() {
        return (
          this.options.filter((x) => x.value === this.value)
          || this.options.filter((x) => x.value === false)
        );
      },
      set(newValue) {
        this.$emit('input', newValue.value);
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
